import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import LandingPage from './LandingPage'
import GameSetup from '../lobby/GameSetup'

interface GameEntryProps {
  onCreateGame: (playerName: string, maxPlayers: number, packId?: string) => void
  onJoinGame: (playerName: string, roomCode?: string) => void
  onShowTutorial: () => void
}

const GameEntry: React.FC<GameEntryProps> = ({ onCreateGame, onJoinGame, onShowTutorial }) => {
  const location = useLocation()
  const [showSetup, setShowSetup] = useState(false)

  useEffect(() => {
    if (location.state && (location.state as any).autoStart) {
      setShowSetup(true)
      // Clear state to avoid reopening on refresh? Not strictly necessary but good practice
      // history.replaceState({}, '') 
    }
  }, [location])

  const handleStartGame = () => {
    setShowSetup(true)
  }

  const handleBack = () => {
    setShowSetup(false)
  }

  if (showSetup) {
    return (
      <GameSetup
        onCreateGame={onCreateGame}
        onJoinGame={onJoinGame}
        onBack={handleBack}
      />
    )
  }

  return (
    <LandingPage
      onStartGame={handleStartGame}
      onShowTutorial={onShowTutorial}
    />
  )
}

export default GameEntry
